<template>
    <div>
        <el-dialog
			title="身份验证"
			v-bind="$attrs"
            :visible.sync="visible"
			width="500px"
            :center="true"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
			custom-class="verification_wrap"
            :modal-append-to-body="false"
			>
            <div slot="title">
                <span class="el-dialog__title">请同意以下协议</span>
                <button class="el-dialog__headerbtn" @click="handleClose">
                    <i class="el-icon-close"></i>
                </button>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;padding-top: 30px;">
                <el-checkbox v-model="checked">
                    <span>阅读并同意<span @click.stop.prevent="goHttps"  target="_blank" style="text-decoration: underline;cursor: pointer;color: #409EFF">《用户信息合法使用承诺书》</span></span>
                </el-checkbox>
            </div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindPhone" :disabled="!checked">确定</el-button>
 			 </span>
		</el-dialog>
    </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
export default {
    name: 'httpsDialog',
    data() {
        return {
            checked: false
        }
    },
	props: {
	    value: {
	        type: Boolean,
	        default: false
	    },
	},
    created() {
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(news) {
                this.$emit('input', news)
            }
        }
    },
    methods: {
        ...mapActions('withdrawal', ['editIsShowMobile']),
        ...mapMutations(['setIsShowMobile']),
        handleClose() {
            this.visible = false
        },
        goHttps() {
            window.open('https://share-h5.chuangzuomao.cn/doubao/yongHuXinXiHeFaShiYongChengNuoShu.html?a=1')
        },
        async bindPhone() {
            await this.editIsShowMobile()
            this.setIsShowMobile(1)
            this.visible = false
        }
    }
}
</script>